// In-App "Delivery rules" authoring state ↔ the stored `delivery` doc (RRS passes it through;
// docs/in-app-sdk-payload.md). D15: `offline_ok: true` lets the device show the message even when its
// last successful /in-app/sync is more than STALE_DAYS old; otherwise the device hides it.
export const STALE_DAYS = 7;

export interface DeliverySettings {
  priority: "low" | "normal" | "high" | "urgent";
  onConflict: "discard" | "queue" | "replace";
  offlineOk: boolean;
  exemptFromGlobalCap: boolean; // DA-BUG-1132: neither counts toward nor is blocked by the tenant cap
}

const PRIORITIES = ["low", "normal", "high", "urgent"];

export function deliveryFromApi(dl: any): DeliverySettings {
  const d = dl && typeof dl === "object" ? dl : {};
  return {
    priority: PRIORITIES.includes(d.priority) ? d.priority : "normal",
    onConflict: ["queue", "replace"].includes(d.on_conflict) ? d.on_conflict : "discard",
    offlineOk: d.offline_ok === true,
    exemptFromGlobalCap: d.exempt_from_global_cap === true,
  };
}

export function deliveryToApi(s: DeliverySettings) {
  return {
    priority: s.priority,
    on_conflict: s.onConflict,
    one_visible_at_a_time: true, // in-app shows one message at a time
    offline_ok: s.offlineOk === true,
    exempt_from_global_cap: s.exemptFromGlobalCap === true, // be-rrs → device exemptFromGlobalCap
  };
}
